import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogImage?: string;
}

export function useSEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'article',
  ogImage,
}: SEOProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }
    if (ogTitle) setMeta('og:title', ogTitle, true);
    if (ogDescription) setMeta('og:description', ogDescription, true);
    setMeta('og:type', ogType, true);
    if (ogImage) setMeta('og:image', ogImage, true);

    return () => {
      document.title = '菲律宾《炽热之夜》电影 — 剧情介绍与观看指南 | 炽热之夜菲律宾电影资讯站';
      setMeta('description', '菲律宾《炽热之夜》是一部备受关注的菲律宾情色剧情电影，融合爱情、欲望与社会现实。本站提供详细剧情介绍、演员阵容、上映信息及正规观看渠道，带影迷全面了解这部菲律宾经典院线作品。');
      const ogTypeEl = document.querySelector('meta[property="og:type"]') as HTMLMetaElement | null;
      if (ogTypeEl) ogTypeEl.setAttribute('content', 'website');
    };
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, ogImage]);
}